import Vue from 'vue'
import { mapState } from 'vuex'
import JobTypeButton from './JobTypeButton/JobTypeButton.vue'
import { DASHBOARD, JOB_ADD, LANDING, VACANCY_ADD } from '@/constants/routes'
import unreadMessagesBlinkTitleMixin from '@/mixins/unreadMessagesBlinkTitleMixin'
import { googleAnalyticsV2 } from '@/servicies-ts/analytics'
import { RootState } from '@/store'
import { AppState } from '@/store/shared/modules/app/types'

export default Vue.extend<any, any, any, any>({
  mixins: [unreadMessagesBlinkTitleMixin],
  components: {
    JobTypeButton,
  },
  data() {
    return {
      selected: null,
      DASHBOARD,
      LANDING,
    }
  },
  computed: {
    ...mapState<RootState>('app', {
      isLoggedIn: (state: AppState): boolean => state.authorized,
    }),
  },
  methods: {
    onSubmit() {
      const name = this.selected === 1 ? JOB_ADD : VACANCY_ADD
      googleAnalyticsV2.send({
        event: 'choose-type-post-job',
        'event-content': this.selected === 1 ? 'freelance_job' : 'full_time_job',
      })
      this.$router.push({ name })
    },
    onInputJobType(type: number) {
      this.selected = type
      googleAnalyticsV2.send({
        event: this.selected === 1 ? 'post_job_free_click' : 'post_job_full_click',
        'event-content': this.selected === 1 ? 'freelance_job' : 'full_time_job',
      })
    },
  },
  metaInfo() {
    return {
      title: this.getMetaTitle('Post a Job'),
    }
  },
})
